<div class="card-container">
    <div class="card">
        <div class="walmart-logo">
            <img class="walmart-logo-img" src="assets/images/WalmartSustainability_Logo_LARGE-01.png" alt="logo" />
        </div>
        <div class="not-supported-external">
            <p class ="browser-not-supported-external">
                Your Browser or version is not supported
            </p>
            <p class="browser-supported-external">
                We support the latest and previous major releases of the following desktop browsers:
            </p> 
            <ol> 
                <li>Microsoft Edge (version 13 or newer)</li> 
                <li>Firefox (version 45 or newer)</li> 
                <li>Chrome (version 53 or newer)</li> 
                <li>Safari (version 10.1 or newer)</li> 
            </ol>
            <p class="browser-supported-external">
                Please switch over to one of the supported browsers to continue.
            </p>
        </div>    
    </div>
</div>
